
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/br/[tickerSymbol]/financials",
      function () {
        return require("private-next-pages/br/[tickerSymbol]/financials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/br/[tickerSymbol]/financials"])
      });
    }
  